import { Tabs } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { DI, DIProps } from '../../../../../Core';
import Order from './Order';
import { Navigate, Route, Routes } from 'react-router-dom';
import Shipment from './Shipment';
import CancellationAndRefund from './CancellationAndRefund';
import { useTranslation } from 'react-i18next';
import RefundOrder from './RefundOrder';

const OrderSettings = (props: DIProps) => {
    const { t } = useTranslation();
    const tabsArray = ['order', 'shipment', 'cancelRefund', 'refundOrder', 'mcf']
    let tabForPath: string = tabsArray.includes(props.match?.["*"] ?? 'order') ? props.match?.["*"] ?? 'order' : 'order'
    const [selected, setSelected] = useState(tabForPath);
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
    const [orderSettingsEnabled, setOrderSettingsEnabled] = useState(true)
    const [showSkeleton, setShowSkeleton] = useState<boolean>(false);
    const [saveLoader, setSaveLoader] = useState<boolean>(false);
    const [getLoader, setGetLoader] = useState(false)

    const firstRender = useRef(true)

    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth < 991);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const tabs = [
        {
            key: 'order',
            id: 'order',
            label: t('Order'),
            disabled: showSkeleton || saveLoader || getLoader,
            children: <>
                <Order setOrderSettingsEnabled={setOrderSettingsEnabled} showSkeleton={showSkeleton} setShowSkeleton={setShowSkeleton} saveLoader={saveLoader} setSaveLoader={setSaveLoader} getLoader={getLoader} setGetLoader={setGetLoader} />
            </>,
        },
        // ...orderSettingsEnabled ? [
        {
            key: 'shipment',
            id: 'shipment',
            label: t('Shipment'),
            disabled: showSkeleton || saveLoader || getLoader,
            children: <>
                <Shipment setOrderSettingsEnabled={setOrderSettingsEnabled} showSkeleton={showSkeleton} setShowSkeleton={setShowSkeleton} saveLoader={saveLoader} setSaveLoader={setSaveLoader} getLoader={getLoader} setGetLoader={setGetLoader} />
            </>,
        },
        {
            key: 'cancelRefund',
            id: 'cancelRefund',
            label: t('Cancelation and Refund'),
            disabled: showSkeleton || saveLoader || getLoader,
            children: <>
                <CancellationAndRefund setOrderSettingsEnabled={setOrderSettingsEnabled} showSkeleton={showSkeleton} setShowSkeleton={setShowSkeleton} saveLoader={saveLoader} setSaveLoader={setSaveLoader} getLoader={getLoader} setGetLoader={setGetLoader} />
            </>,
        },
        // {
        //     key: 'refundOrder',
        //     id: 'refundOrder',
        //     label: t('Sync Return Orders on Shopify'),
        //     disabled: showSkeleton || saveLoader || getLoader,
        //     children: <>
        //         <RefundOrder
        //             RefundOrder setOrderSettingsEnabled={setOrderSettingsEnabled} showSkeleton={showSkeleton} setShowSkeleton={setShowSkeleton} saveLoader={saveLoader} setSaveLoader={setSaveLoader} getLoader={getLoader} setGetLoader={setGetLoader} />
        //     </>,
        // }
    ];

    useEffect(() => {
        setSelected(tabForPath)
    }, [tabForPath])

    useEffect(() => {
        if (orderSettingsEnabled || firstRender) {
            firstRender.current = false
            return;
        }
        setSelected('order'); props.history('order')
    }, [orderSettingsEnabled])

    return (<>
        <div className='Custom__Vertical--Tab'>
            <Tabs
                tabPosition={isSmallScreen ? "top" : "left"}
                onChange={(e) => { setSelected(e); props.history(e) }}
                items={tabs}
                activeKey={selected}
                destroyInactiveTabPane
            />
            <Routes>
                <Route path={selected} element={<></>} />
                <Route path='*' element={<Navigate to={'order'} />} />
            </Routes>
        </div >
    </>
    );
}

export default DI(OrderSettings);